import { Type } from '@angular/core';
import { ContentArea } from '../../core/models/invoice/invoice-document-detail.model';
import { BaseInvoiceThemeModel } from '../../core/models/invoice/base-invoice-theme.model';

export type InvoiceHandlingMode = 'create' | 'edit' | 'print';

export type SectionId<T extends string = string> = T & { __brand: 'SectionId' };
export interface SectionDefinition<TId extends SectionId = SectionId> {
  id: TId;
  group: string; // Group of sections,
  label: string; // human-readable, i18n-able.
  defaultContent: ContentArea;
}

export interface ThemeDefinition<TId extends SectionId = SectionId> {
  id: number;
  title: string; // for menus
  componentLoader: () => Promise<Type<any>>;
  sections: readonly SectionDefinition<TId>[];
  defaultTheme: BaseInvoiceThemeModel;
}

export enum ThemeTypes {
  StandardInvoiceTheme,
  MinimalInvoiceTheme,
}

export enum SectionType {
  HTML = 'html',
  Image = 'image',
  Undefined = 'undefined',
}

// Types for document editing initiation =>
// - EditDocumentType is the either text or image, so either a WYSIWYG editor or an image upload is shown.
// - HTMLElement is the html part that needs to be updated in
// the document preview if user changes WYSIWYG editor or changes an image.
// - The section id of the corresponding section.
export interface EditSectionSelection {
  type: SectionType;
  sectionId: SectionId;
}
